import { useEffect, useState } from "react";
import { ReservePropertiesTypes } from "./reserve-nearby.types";

export const useNearBy = (properties: ReservePropertiesTypes) => {
  const { nearbyLocations, roadAccessType, roadAccessDescription } = properties;
  const firstData = nearbyLocations?.slice(0, 6);
  const remainingData = nearbyLocations?.slice(6);
  const [showMore, setShowMore] = useState(false);
  useEffect(() => {
    setShowMore(
      !(Array.isArray(nearbyLocations) && nearbyLocations?.length > 6)
    );
  }, [nearbyLocations]);

  const distances = {
    LT_5_MINUTES: "کمتر از 5 دقیقه",
    LT_10_MINUTES: "کمتر از 10 دقیقه",
    LT_15_MINUTES: "کمتر از 15 دقیقه",
    LT_20_MINUTES: "کمتر از 20 دقیقه",
    LT_30_MINUTES: "کمتر از 30 دقیقه",
    GT_30_MINUTES: "بیشتر از 30 دقیقه"
  };
  const places = {
    SUPERMARKET: "سوپرمارکت",
    BAKERY: "نانوایی",
    AIRPORT: "فرودگاه",
    BUS_STATION: "پایانه اتوبوس‌رانی",
    SUBWAY_STATION: "ایستگاه راه‌آهن",
    TRAIN_STATION: "ایستگاه مترو",
    RESTAURANT: "رستوران",
    MALL: "مرکز خرید",
    GAS_STATION: "پمپ بنزین",
    SEA: "دریا",
    JUNGLE: "جنگل",
    HOLY_SHRINE: "حرم",
    SHOPPING_MALL: "مراکز خرید",
    BEACH: "دریا",
    HOSPITAL: "بیمارستان",
    PHARMACY: "داروخانه",
    BANK: "بانک"
  };
  const roadTypes = {
    ASPHALT: "آسفالت",
    DIRT: "خاکی",
    PAVEMENT: "پیاده‌راه‌"
  };
  const clickShowMore = () => {
    setShowMore(true);
  };

  return {
    places,
    distances,
    roadTypes,
    firstData,
    remainingData,
    roadAccessType,
    roadAccessDescription,
    clickShowMore,
    showMore
  };
};
